<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    fill: {
      type: String,
      default: '#000',
    },
    datum: {
      type: Object,
    },
  },

  methods: {
    onClick() {
      if (this.datum) this.$emit('datum:click', this.datum);
    },
    onMouseover() {
      if (this.datum) this.$emit('datum:mouseover', this.datum);
    },
    onMouseout() {
      if (this.datum) this.$emit('datum:mouseout', this.datum);
    },
  },
};
</script>
